module.exports = __webpack_public_path__ + "static/media/gray_pin.8a820efa.webp";